var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "sort-btn-item" }, [
    _c(
      "span",
      {
        on: {
          click: function($event) {
            _vm.syncModel(true)
          }
        }
      },
      [
        _vm._v("\n    " + _vm._s(_vm.label) + " "),
        _c("i", {
          staticClass: "icon iconfont",
          class: {
            "icon-arrow-top": _vm.curValue == "asc",
            "icon-arrow-bottom": _vm.curValue == "desc"
          },
          staticStyle: { "vertical-align": "middle" }
        })
      ]
    )
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-14eceaea", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-14eceaea","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/compo/query/QuerySortField.vue
// module id = 1685
// module chunks = 1